module.exports = __webpack_public_path__ + "img/hc_pro_four_3.0bbe63bb.jpg";